<template>
  <b-card no-body class="my-2">
    <b-card-header class="card-header-results">
      <div class="card-header-result-name">
      <b-icon
        @click="toggleCollapse()"
        :icon="expanded ? 'dash' : 'plus'"
        v-b-tooltip.hover.top :title=" expanded ? 'mai putin' :'mai mult'"
        class="mx-2" />
        <strong>{{ result.label }}</strong>
      </div>
      <div class="price-and-status">
        <span class="text-primary ml-2" style="cursor: pointer;" @click="$emit('priceDetails')"> <b>pret: {{ result.price + result.tax }} EUR</b></span>
      </div>
    </b-card-header>
    <b-card-body v-if="!collapsed">
      <b-row>
        <b-col md="12">
           <div class="d-flex justify-content-between align-content-center hh-t-head p-2 mb-1">
            <!-- <span><strong>Autocar: </strong>{{ result.bus_name }}</span> -->
            <span><strong>Plecare din: </strong>{{ result.from_name }}</span>
            <span><strong>Sosire la: </strong>{{ result.to_name }}</span>
          </div>
        </b-col>
        <b-col md="4">
          <img :src="result.image" class="img-fluid w-100 d-block" />
        </b-col>
        <b-col md="8">
          <b-row>
            <b-col sm="12" class="d-flex align-items-center" v-if="result.description">
              <p>{{ result.description }}</p>
            </b-col>
            <b-col cols="12" class="mb-1">
              <b-card no-body class="mb-0">
                <b-row no-gutters class="align-items-center bg-light p-2 m-0">
                  <div class="w-100 d-flex flex-column">
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">Plecare:</strong>
                      <span class="mb-0">{{ outDep }}</span>
                    </div>
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">De la:</strong>
                      <span class="mb-0">{{ result.dep_pick_up_details || result.from_name }} </span>
                    </div>
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">Sosire:</strong>
                      <span class="mb-0">{{ outArr }}</span>
                    </div>
                    <div class="d-flex align-items-baseline mb-0">
                      <strong class="mr-2 mb-0 dep-leg">La:</strong>
                      <span class="mb-0">{{ result.dep_drop_off_details || result.to_name }}</span>
                    </div>
                    <div v-if="result.out_duration" class="d-flex align-items-baseline mb-0">
                      <strong class="mr-2 mb-0 dep-leg">Durata:</strong>
                      <span class="mb-0">{{ result.out_duration }}h</span>
                    </div>
                  </div>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="12" v-if="params.route_type === 'return'">
              <b-card no-body class="mb-0">
                <b-row no-gutters class="align-items-center bg-light p-2 m-0">
                  <div class="w-100 d-flex flex-column">
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">Intoarcere:</strong>
                      <span class="mb-0">{{ inDep }}</span>
                    </div>
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">De la:</strong>
                      <span class="mb-0">{{ result.dest_pick_up_details || result.to_name }}</span>
                    </div>
                    <div class="d-flex align-items-baseline mb-1">
                      <strong class="mr-2 mb-0 dep-leg">Sosire:</strong>
                      <span class="mb-0">{{ inArr }}</span>
                    </div>
                    <div class="d-flex align-items-baseline mb-0">
                      <strong class="mr-2 mb-0 dep-leg">La:</strong>
                      <span class="mb-0">{{ result.dest_drop_off_details || result.to_name }}</span>
                    </div>
                    <div v-if="result.in_duration" class="d-flex align-items-baseline mb-0">
                      <strong class="mr-2 mb-0 dep-leg">Durata:</strong>
                      <span class="mb-0">{{ result.in_duration }}h</span>
                    </div>
                  </div>
                </b-row>
              </b-card>
            </b-col>
            <b-col md="12" v-if="showBook">
              <hr>
              <b-button variant="primary" size="sm" class="float-right" @click="$emit('book')">
                <b-icon icon="card-checklist" class="mr-2"/> Rezerva
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'

const getDateTime = (val, time) => {
  const date = moment.unix(val).format('DD-MM-YYYY')
  return time ? `${date} ${time}` : date
}

export default {
  props: {
    result: {
      type: Object,
      mandatory: true
    },
    params: {
      type: Object,
      mandatory: true
    },
    expanded: {
      type: Boolean,
      default: true
    },
    showBook: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      collapsed: false
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  },
  created () {
    this.collapsed = !this.expanded
  },
  computed: {
    outDep () { return getDateTime(this.result.out_departure, this.result.out_departure_time, this.result.out_departure_date) },
    outArr () { return getDateTime(this.result.out_arrival, this.result.out_arrival_time, this.result.out_arrival_date) },
    inDep () { return getDateTime(this.result.in_departure, this.result.in_departure_time, this.result.in_departure_date) },
    inArr () { return getDateTime(this.result.in_arrival, this.result.in_arrival_time, this.result.in_arrival_date) }
  }
}
</script>
